export const categories = [
  {
    id: 'jiaoyou',
    name: '交友配对',
    slug: 'jiaoyou',
    description: '寻找志同道合的伙伴，建立真实有意义的连接',
    icon: 'ri-heart-line',
  },
  {
    id: 'zixun',
    name: '社区资讯',
    slug: 'zixun',
    description: 'LGBTQ+ 最新动态、政策解读与权益保护',
    icon: 'ri-newspaper-line',
  },
  {
    id: 'huodong',
    name: '活动聚会',
    slug: 'huodong',
    description: '线上线下活动，认识更多朋友',
    icon: 'ri-calendar-event-line',
  },
  {
    id: 'zhichi',
    name: '心理支持',
    slug: 'zhichi',
    description: '专业心理咨询与社群互助',
    icon: 'ri-mental-health-line',
  },
  {
    id: 'shenghuo',
    name: '生活分享',
    slug: 'shenghuo',
    description: '日常生活、旅行、美食与兴趣分享',
    icon: 'ri-share-line',
  },
  {
    id: 'jiankang',
    name: '健康科普',
    slug: 'jiankang',
    description: '性健康知识、疾病预防与科学指导',
    icon: 'ri-heart-pulse-line',
  },
];

export const articles = [
  {
    id: 'article-1',
    title: '如何在社群中找到真正的归属感',
    slug: 'ruhe-zai-shequn-zhong-zhaodao-guishugan',
    summary: '归属感是人类基本需求之一。对于男同群体来说，找到一个让自己感到安全和被接纳的社群尤为重要。本文探讨建立深层连接的五个关键步骤。',
    content: `<p>归属感是人类基本需求之一。对于男同群体来说，找到一个让自己感到安全和被接纳的社群尤为重要。</p>
      <h2>什么是真正的归属感</h2>
      <p>归属感不仅仅是加入一个群体，而是感到自己被真正地看见、理解和接纳。在LGBTQ+社群中，这种感受尤其珍贵。</p>
      <h2>建立深层连接的五个步骤</h2>
      <h3>1. 真诚地做自己</h3>
      <p>真正的连接始于真实的自我表达。当你敢于展示真实的自己时，你吸引到的也将是真正欣赏你的人。</p>
      <h3>2. 主动参与社群活动</h3>
      <p>无论是线上讨论还是线下聚会，主动参与是建立连接的第一步。不要害怕迈出第一步。</p>
      <h3>3. 学会倾听与分享</h3>
      <p>良好的关系建立在相互理解的基础上。学会倾听他人的故事，也勇于分享自己的经历。</p>
      <h3>4. 保持开放心态</h3>
      <p>社群中有各种各样的人，保持开放和包容的心态，你会发现每个人都有独特的闪光点。</p>
      <h3>5. 持续投入时间</h3>
      <p>深厚的友谊需要时间培养。持续地参与和贡献，你会逐渐成为社群中不可或缺的一份子。</p>
      <h2>结语</h2>
      <p>归属感不是一蹴而就的，它需要勇气、耐心和真诚。但当你找到那个让你感到温暖的地方时，一切努力都值得。</p>`,
    category: 'jiaoyou',
    coverImage: 'https://readdy.ai/api/search-image?query=Warm%20intimate%20community%20gathering%20with%20soft%20natural%20lighting%2C%20modern%20cozy%20cafe%20interior%2C%20diverse%20people%20connecting%2C%20warm%20terracotta%20and%20cream%20tones%2C%20editorial%20lifestyle%20photography%2C%20soft%20shadows%2C%20harmonious%20atmosphere%2C%20clean%20minimalist%20aesthetic&width=800&height=500&seq=article-1-cover&orientation=landscape',
    author: '晨曦',
    publishedAt: '2026-08-08',
    readTime: '8分钟',
  },
  {
    id: 'article-2',
    title: '出柜指南：如何与家人坦诚沟通',
    slug: 'chugui-zhinan-ruhe-yu-jiaren-tancheng-goutong',
    summary: '出柜是每个男同人生中的重要时刻。本文提供实用的沟通技巧和心理准备建议，帮助你以最温和的方式与家人分享真实的自己。',
    content: `<p>出柜是每个男同人生中的重要时刻。本文提供实用的沟通技巧和心理准备建议，帮助你以最温和的方式与家人分享真实的自己。</p>
      <h2>出柜前的心理准备</h2>
      <p>在决定出柜之前，确保你已经做好了充分的心理准备。你不是一个人，整个社群都在你身后。</p>
      <h2>选择合适的时机</h2>
      <p>选择一个平静、私密的环境，确保有足够的时间进行深入的对话。避免在家庭聚会或节假日等高压场合出柜。</p>
      <h2>沟通技巧</h2>
      <p>用"我"开头的陈述句表达感受，避免指责性语言。给家人时间消化信息，不要期待即时接受。</p>
      <h2>结语</h2>
      <p>每个人的出柜经历都是独特的。无论结果如何，请记住你的价值不应由他人的接受程度来定义。</p>`,
    category: 'zhichi',
    coverImage: 'https://readdy.ai/api/search-image?query=Warm%20supportive%20conversation%20between%20two%20people%20in%20cozy%20living%20room%2C%20soft%20sunlight%20through%20window%2C%20gentle%20caring%20atmosphere%2C%20minimalist%20interior%2C%20cream%20and%20sage%20green%20tones%2C%20emotional%20editorial%20photography%2C%20tender%20moment&width=800&height=500&seq=article-2-cover&orientation=landscape',
    author: '心语',
    publishedAt: '2026-08-06',
    readTime: '12分钟',
  },
  {
    id: 'article-3',
    title: '2026年LGBTQ+权益保护最新政策解读',
    slug: '2026-lgbtq-quanyi-baohu-zuixin-zhengce-jiedu',
    summary: '了解最新的LGBTQ+权益保护政策变化，包括反歧视法规、医疗权益、婚姻平权等方面的最新进展。',
    content: `<p>了解最新的LGBTQ+权益保护政策变化，包括反歧视法规、医疗权益、婚姻平权等方面的最新进展。</p>
      <h2>反歧视法规最新动态</h2>
      <p>2026年，多地在反就业歧视方面取得了重要进展。了解这些变化对你的权益保护至关重要。</p>
      <h2>医疗权益保障</h2>
      <p>LGBTQ+群体在医疗领域面临的特殊需求逐渐得到关注和改善。</p>
      <h2>未来展望</h2>
      <p>虽然还有很长的路要走，但每一步进展都值得庆祝。社群的力量正在推动积极的变化。</p>`,
    category: 'zixun',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20clean%20legal%20office%20with%20warm%20lighting%2C%20documents%20and%20books%2C%20professional%20yet%20warm%20atmosphere%2C%20minimalist%20design%2C%20terracotta%20and%20cream%20accents%2C%20editorial%20style%2C%20soft%20natural%20light&width=800&height=500&seq=article-3-cover&orientation=landscape',
    author: '法眼',
    publishedAt: '2026-08-04',
    readTime: '10分钟',
  },
  {
    id: 'article-4',
    title: '彩虹跑活动回顾：200人齐聚为爱发声',
    slug: 'caihong-pao-huodong-huigu',
    summary: '上周末的彩虹公益跑活动圆满结束，200多位社群成员齐聚城市公园，用脚步传递爱与包容的力量。',
    content: `<p>上周末的彩虹公益跑活动圆满结束，200多位社群成员齐聚城市公园，用脚步传递爱与包容的力量。</p>
      <h2>活动盛况</h2>
      <p>清晨的阳光洒在城市公园的跑道上，200多位身着彩虹色服饰的参与者汇聚一堂。活动现场充满了欢声笑语和温暖的拥抱。</p>
      <h2>精彩瞬间</h2>
      <p>从热身运动到冲刺终点，每一个环节都充满了能量和感动。许多参与者表示这是他们参加过最温暖的社群活动。</p>
      <h2>活动意义</h2>
      <p>彩虹跑不仅仅是一场运动，更是一次爱的宣言。我们用行动证明，爱就是爱，无需解释。</p>`,
    category: 'huodong',
    coverImage: 'https://readdy.ai/api/search-image?query=Colorful%20community%20running%20event%20in%20sunny%20park%2C%20rainbow%20colors%2C%20diverse%20people%20celebrating%2C%20joyful%20atmosphere%2C%20warm%20golden%20hour%20lighting%2C%20lifestyle%20photography%2C%20energetic%20and%20uplifting%2C%20clean%20composition&width=800&height=500&seq=article-4-cover&orientation=landscape',
    author: '阳光',
    publishedAt: '2026-08-02',
    readTime: '6分钟',
  },
  {
    id: 'article-5',
    title: '男性健康：定期体检的重要性',
    slug: 'nanxing-jiankang-dingqi-tijian-zhongyaoxing',
    summary: '定期健康体检对于男同群体尤为重要。了解应该做哪些检查、多久检查一次，守护自己的身体健康。',
    content: `<p>定期健康体检对于男同群体尤为重要。了解应该做哪些检查、多久检查一次，守护自己的身体健康。</p>
      <h2>为什么定期体检很重要</h2>
      <p>很多健康问题在早期没有明显症状，定期体检可以帮助及早发现潜在风险。</p>
      <h2>建议的检查项目</h2>
      <p>包括常规血液检查、性传播疾病筛查、心理健康评估等。根据个人情况，医生可能会建议额外的检查。</p>
      <h2>如何克服体检焦虑</h2>
      <p>很多人对体检有恐惧感，但请记住，了解自己的身体状况是爱自己的表现。</p>`,
    category: 'jiankang',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20clean%20medical%20clinic%20interior%20with%20warm%20lighting%2C%20professional%20healthcare%20setting%2C%20calm%20reassuring%20atmosphere%2C%20sage%20green%20and%20cream%20tones%2C%20minimalist%20design%2C%20soft%20natural%20light%2C%20professional%20photography&width=800&height=500&seq=article-5-cover&orientation=landscape',
    author: '康康',
    publishedAt: '2026-07-30',
    readTime: '7分钟',
  },
  {
    id: 'article-6',
    title: '一人食也要精致：独居男生的美食日记',
    slug: 'yiren-shi-ye-yao-jingzhi-duju-nansheng-meishi-riji',
    summary: '独居生活也可以很精彩！分享简单易做的健康食谱，让你的每一餐都充满仪式感和幸福感。',
    content: `<p>独居生活也可以很精彩！分享简单易做的健康食谱，让你的每一餐都充满仪式感和幸福感。</p>
      <h2>独居烹饪的乐趣</h2>
      <p>为自己做一顿饭，是对自己最好的犒劳。不需要太复杂，简单的食材也能做出美味。</p>
      <h2>推荐食谱</h2>
      <p>从快手早餐到精致的晚餐，我们整理了一系列适合独居男生的健康食谱。</p>
      <h2>仪式感的重要性</h2>
      <p>即使一个人吃饭，也要用心摆盘、点一支蜡烛、放一首喜欢的音乐。生活需要仪式感。</p>`,
    category: 'shenghuo',
    coverImage: 'https://readdy.ai/api/search-image?query=Beautiful%20home%20cooking%20scene%20with%20warm%20lighting%2C%20elegant%20table%20setting%20for%20one%2C%20minimalist%20modern%20kitchen%2C%20fresh%20ingredients%2C%20cozy%20atmosphere%2C%20terracotta%20and%20cream%20palette%2C%20lifestyle%20food%20photography%2C%20soft%20shadows&width=800&height=500&seq=article-6-cover&orientation=landscape',
    author: '美食家阿杰',
    publishedAt: '2026-07-28',
    readTime: '5分钟',
  },
  {
    id: 'article-7',
    title: '学会爱自己：男同心理健康自助指南',
    slug: 'xuehui-ai-ziji-nantong-xinli-jiankang-zizhu-zhinan',
    summary: '自我接纳是心理健康的基础。本文提供实用的自我关怀练习，帮助你建立积极的自我形象和健康的心理状态。',
    content: `<p>自我接纳是心理健康的基础。本文提供实用的自我关怀练习，帮助你建立积极的自我形象和健康的心理状态。</p>
      <h2>自我接纳的意义</h2>
      <p>对于男同群体来说，自我接纳往往是一条漫长的道路。社会压力、刻板印象和内化的羞耻感都可能成为障碍。</p>
      <h2>每日自我关怀练习</h2>
      <p>从正念冥想到感恩日记，这些简单的练习可以帮助你建立与自己的健康关系。</p>
      <h2>寻求专业帮助</h2>
      <p>当你感到难以独自应对时，寻求心理咨询师的帮助是勇敢的表现，而不是软弱。</p>`,
    category: 'zhichi',
    coverImage: 'https://readdy.ai/api/search-image?query=Peaceful%20meditation%20space%20with%20warm%20sunlight%2C%20minimalist%20room%20with%20plants%2C%20calm%20serene%20atmosphere%2C%20soft%20cream%20and%20sage%20tones%2C%20wellness%20lifestyle%20photography%2C%20gentle%20shadows%2C%20harmonious%20composition&width=800&height=500&seq=article-7-cover&orientation=landscape',
    author: '心语',
    publishedAt: '2026-07-25',
    readTime: '9分钟',
  },
  {
    id: 'article-8',
    title: '同志情侣相处之道：五个让感情更稳固的建议',
    slug: 'tongzhi-qinglv-xiangchu-zhidao',
    summary: '健康的恋爱关系需要双方共同努力。从沟通技巧到冲突解决，分享让男同情侣关系更加稳固的实用建议。',
    content: `<p>健康的恋爱关系需要双方共同努力。从沟通技巧到冲突解决，分享让男同情侣关系更加稳固的实用建议。</p>
      <h2>建立信任基础</h2>
      <p>信任是一切关系的基石。坦诚沟通、相互尊重是建立信任的关键。</p>
      <h2>处理冲突的艺术</h2>
      <p>每对情侣都会有分歧，关键在于如何处理。学会"战"而不是"胜"。</p>
      <h2>保持新鲜感</h2>
      <p>长期关系需要用心经营。定期约会、尝试新事物、保持惊喜，让爱情持续升温。</p>`,
    category: 'jiaoyou',
    coverImage: 'https://readdy.ai/api/search-image?query=Two%20people%20holding%20hands%20at%20sunset%2C%20warm%20golden%20light%2C%20intimate%20romantic%20moment%2C%20soft%20focus%20background%2C%20warm%20terracotta%20and%20amber%20tones%2C%20editorial%20couple%20photography%2C%20tender%20atmosphere&width=800&height=500&seq=article-8-cover&orientation=landscape',
    author: '晨曦',
    publishedAt: '2026-07-22',
    readTime: '11分钟',
  },
  {
    id: 'article-9',
    title: '同志友好城市排行榜：2026年最包容的城市',
    slug: 'tongzhi-youhao-chengshi-paihangbang-2026',
    summary: '我们整理了2026年对LGBTQ+群体最友好的城市排名，从政策包容度、社群活跃度到生活便利性多维度评估。',
    content: `<p>我们整理了2026年对LGBTQ+群体最友好的城市排名，从政策包容度、社群活跃度到生活便利性多维度评估。</p>
      <h2>评选标准</h2>
      <p>我们综合考量了政策法规、社群活跃度、医疗资源、文化氛围等多个维度。</p>
      <h2>城市排名</h2>
      <p>各大城市在包容性方面各有特色，有些在政策上领先，有些在社群文化上更为丰富。</p>
      <h2>选择适合你的城市</h2>
      <p>每个人对"友好"的定义不同，找到最适合自己的城市才是最重要的。</p>`,
    category: 'zixun',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20city%20skyline%20at%20sunset%20with%20warm%20golden%20light%2C%20urban%20landscape%20with%20rainbow%20flag%20colors%20subtly%20integrated%2C%20inclusive%20diverse%20atmosphere%2C%20clean%20modern%20photography%2C%20warm%20amber%20tones%2C%20optimistic%20mood&width=800&height=500&seq=article-9-cover&orientation=landscape',
    author: '城市观察员',
    publishedAt: '2026-07-20',
    readTime: '8分钟',
  },
];

export const homeData = {
  heroTitle: '找到属于你的彩虹社区',
  heroSubtitle: '安全、温暖、真实的男同交友与资讯平台',
  heroCta: '开始探索',
  stats: [
    { value: '50,000+', label: '社群成员' },
    { value: '200+', label: '城市覆盖' },
    { value: '1,000+', label: '优质文章' },
    { value: '98%', label: '用户好评' },
  ],
  featuredTitle: '精选文章',
  faqTitle: '常见问题',
  faqs: [
    {
      question: '男同网站是免费的吗？',
      answer: '是的，男同网站的基础功能完全免费。我们致力于为男同群体提供一个开放、友好的交流平台，所有核心功能均可免费使用。',
    },
    {
      question: '如何保护我的隐私？',
      answer: '我们采用严格的隐私保护措施，您可以选择匿名使用，个人信息完全由您控制。我们不会向第三方泄露任何用户数据。',
    },
    {
      question: '如何加入社群活动？',
      answer: '您可以在活动板块查看即将举办的活动，线上活动可直接报名参加，线下活动会提供详细的时间地点信息。',
    },
    {
      question: '网站上的信息可靠吗？',
      answer: '所有资讯类内容都经过编辑团队审核，健康科普内容由专业医疗顾问把关，确保信息的准确性和可靠性。',
    },
    {
      question: '可以在这里找到伴侣吗？',
      answer: '我们的交友功能帮助许多人找到了志同道合的伙伴。但请记住，建立有意义的关系需要时间和真诚的交流。',
    },
  ],
  aboutHighlights: [
    { icon: 'ri-shield-check-line', title: '安全第一', description: '严格的身份验证和隐私保护机制' },
    { icon: 'ri-user-heart-line', title: '社群驱动', description: '由社群成员共建的温暖空间' },
    { icon: 'ri-award-line', title: '品质保证', description: '专业团队审核内容质量' },
    { icon: 'ri-global-line', title: '多元包容', description: '尊重每一个体的独特性' },
  ],
};